<evc-modal [showReduceButton]="false" (closeModal)="closeDialog()">
  <div class="header" modal-title>
    <h4 class="dialog-title">
      {{ "summaryCommentDialog.title" | translate }}
    </h4>
  </div>

  <div class="dialog-container" modal-content>
    <div class="dialog-title">{{ locationName }}</div>

    <label for="textarea">{{ "summaryCommentDialog.comment" | translate }}</label>
    <textarea id="textarea" class="textarea" #textarea [formControl]="commentControl" [maxlength]="commentMaxLength"> </textarea>

    <div class="hint">{{ commentControl.value?.length || 0 }}/{{ commentMaxLength }}</div>
  </div>

  <div class="actions" modal-actions>
    <evc-nav-button
      class="button"
      type="primary"
      variant="square"
      size="lg"
      (ctaClicked)="onSave()"
      [disabled]="commentControl.invalid || (isEmpty && !hasInitialComment)"
    >
      {{ "summaryCommentDialog.save" | translate }}
    </evc-nav-button>
  </div>
</evc-modal>
